module.exports = __webpack_public_path__ + "img/vegetable-rutabaga-350x184.06b51b7a.jpg";